module.exports = __webpack_public_path__ + "static/media/subtract.d269ee5c.svg";